module.exports = __webpack_public_path__ + "b5d779d0882ae8940563be6ad1d35c25.png";